import { render, staticRenderFns } from "./veStuYystuEdit.vue?vue&type=template&id=198b2084&scoped=true"
import script from "./veStuYystuEdit.vue?vue&type=script&lang=js"
export * from "./veStuYystuEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198b2084",
  null
  
)

export default component.exports